/**
 * ============================================================
 * S3: custom-price-calculator.js
 * WholesaleTumblers — 动态价格明细 (v4)
 *
 * 功能:
 *   1. Quantity 右侧显示: Total: $xxx.xx (加粗) / $x.xx ea × qty (小字)
 *   2. 页面加载自动设置 Quantity = MOQ
 *   3. 联动 Dawn 原生价格显示（选变体时更新实际价格）
 *
 * 依赖:
 *   - window.__WT_PRICE_TIERS (由 S1 注入)
 *
 * 加载: layout/theme.liquid → </body> 前
 * 更新: 2026-05-13 v4
 * ============================================================
 */
(function() {
  'use strict';

  var DATA = window.__WT_PRICE_TIERS;
  if (!DATA || !DATA.tiers || !DATA.tiers.length) return;

  /* ── 工具函数 ── */

  function getBasePrice(vid) {
    for (var i = 0; i < DATA.variants.length; i++) {
      if (DATA.variants[i].id === vid) return DATA.variants[i].price;
    }
    return DATA.variants[0].price;
  }

  function getSelectedImprint(vid) {
    var idx = DATA.imprintOptionIndex;
    if (idx < 0) return 'Blank';
    for (var i = 0; i < DATA.variants.length; i++) {
      if (DATA.variants[i].id === vid) return DATA.variants[i].options[idx] || 'Blank';
    }
    return 'Blank';
  }

  function getSurcharge(name) {
    if (!DATA.surcharges) return 0;
    if (DATA.surcharges[name] !== undefined) return DATA.surcharges[name];
    var lower = name.toLowerCase();
    for (var k in DATA.surcharges) {
      if (k.toLowerCase() === lower) return DATA.surcharges[k];
    }
    return 0;
  }

  /* ── WT: Imprint 按钮显示名映射 (仅供 legend 标题即时更新复用) ──
   * 2026-07-22 下沉: 顺序重排 (wtImprintSortWeight/applyImprintDisplayOrder(All))
   * 与加价标签注入 (updateVariantLabels) 已整体删除 —— 现在由
   * snippets/product-variant-options.liquid 服务端直接渲染, 首帧即正确,
   * 不再需要 JS 事后处理/100ms 轮询自愈。这个函数本身保留, 因为
   * legend "Imprint: 当前值" 标题在用户点击同一 fieldset 内的 radio 时
   * 需要同一 tick 内即时更新 (Dawn 不会重新整段渲染, 见下方 updateLegendText),
   * 别名只用于识别, 标准显示名恒为项目既定 canonical 命名。 */
  function wtImprintDisplayName(raw) {
    if (!raw) return raw;
    var v = String(raw).trim();
    var lower = v.toLowerCase();
    if (lower === 'blank') return 'Blank';
    if (lower.indexOf('laser') > -1) return 'Laser Engraved';
    if (/(^|\s)1[\s-]*color/i.test(v) || /(^|\s)one[\s-]*color/i.test(v)) return '1 Color Print';
    if (lower.indexOf('full color') > -1 || lower.indexOf('full-color') > -1) return 'Full Color Imprint';
    return raw;
  }

  function getDiscount(qty) {
    var d = 0;
    for (var i = 0; i < DATA.tiers.length; i++) {
      if (qty >= DATA.tiers[i].qty) d = DATA.tiers[i].discount;
    }
    return d;
  }

  function getCurrentVariantId() {
    // 1. 最精确：直接从当前选中的 radios 获取
    var checked = document.querySelectorAll('variant-radios input[type="radio"]:checked, variant-selects select');
    var selectedOptions = [];
    for (var i = 0; i < checked.length; i++) {
      selectedOptions.push(checked[i].value);
    }
    if (selectedOptions.length > 0) {
      for (var j = 0; j < DATA.variants.length; j++) {
        var v = DATA.variants[j];
        var match = true;
        for (var k = 0; k < v.options.length; k++) {
          if (selectedOptions.indexOf(v.options[k]) === -1) { match = false; break; }
        }
        if (match) return v.id;
      }
    }
    
    // 2. URL fallback
    var p = new URLSearchParams(window.location.search);
    var v = p.get('variant');
    if (v) return parseInt(v, 10);
    
    // 3. Hidden input fallback
    var h = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (h) return parseInt(h.value, 10);
    
    return DATA.currentVariantId;
  }

  function fmt(n) { return '$' + n.toFixed(2); }

  /* ── 创建 UI ── */

  function createWidget() {
    var widget = document.createElement('div');
    widget.id = 'wt-custom-calc';
    widget.className = 'wt-price-calc';
    
    // We do NOT set flex-end here anymore, as the parent wrapper will handle layout
    widget.innerHTML = 
      '<div style="text-align: right;">' +
        '<div class="wt-price-calc__total-line" style="font-size: 1.6rem; font-weight: 700; line-height: 1.3; color: #1a1a1a;">' +
          '<span style="font-size: 1.1rem; margin-right: 0.5rem;">Total:</span>' +
          '<span id="wt-calc-total"></span>' +
        '</div>' +
        '<div id="wt-calc-detail" class="wt-price-calc__detail-line" style="font-size: 1.1rem; color: #555; margin-top: 0.5rem; line-height: 1.4;"></div>' +
        '<div id="wt-calc-save-row" class="wt-price-calc__save-line" style="display:none; font-size: 0.95rem; color: #15803d; font-weight: 600; margin-top: 0.2rem; line-height: 1.4;">' +
          'You Save: <span id="wt-calc-save"></span>' +
        '</div>' +
      '</div>';
      
    return widget;
  }

  /* ── 插入到 Quantity input 右侧 ── */

  function insertWidget(widget) {
    var qtyInput = document.querySelector('quantity-input');
    if (!qtyInput) return;
    
    var wrapper = document.getElementById('wt-price-calc-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = 'wt-price-calc-wrapper';
      wrapper.style.display = 'flex';
      wrapper.style.justifyContent = 'space-between';
      wrapper.style.alignItems = 'flex-end';
      wrapper.style.gap = '1.5rem';
      wrapper.style.maxWidth = '44rem';
      wrapper.style.marginBottom = '1.5rem';
      
      qtyInput.parentNode.insertBefore(wrapper, qtyInput);
      
      var leftBox = document.createElement('div');
      var label = document.querySelector('label[for="' + qtyInput.querySelector('input').id + '"]') || document.querySelector('label.form__label');
      if (label) leftBox.appendChild(label);
      leftBox.appendChild(qtyInput);
      
      wrapper.appendChild(leftBox);
    }

    wrapper.appendChild(widget);
  }

  /* ── 强制接管 Dawn 原生价格显示与 MOQ (对抗 AJAX 刷新) ── */
  var lastValidQty = DATA.moq;

  function enforceState() {
    var vid = getCurrentVariantId();
    var imprint = getSelectedImprint(vid);
    var targetMoq = DATA.moq;
    if (DATA.variant_moqs && DATA.variant_moqs[imprint]) {
       targetMoq = DATA.variant_moqs[imprint];
    }

    // 强制 MOQ & 记忆恢复
    var inp = document.querySelector('quantity-input input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    if (inp && targetMoq > 1) {
      var current = parseInt(inp.value, 10) || 1;
      
      if (current < targetMoq && document.activeElement !== inp) {
        // 如果 Dawn AJAX 强制重置为了 1，但我们之前记住了更大的数字，就恢复它
        var restoreQty = (lastValidQty >= targetMoq) ? lastValidQty : targetMoq;
        inp.value = restoreQty;
        inp.setAttribute('value', restoreQty);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (current >= targetMoq) {
        // 只要当前输入是合法且有效的，就记录下来
        lastValidQty = current;
      }
    }
  }

  // 改为在 update() 中调用 enforceState，然后由 setInterval 定时刷新 update

  /* ── 更新计算 ── */

  function update() {
    enforceState(); // 每次更新前先强制纠正 Dawn 状态
    // WT 2026-07-22: 顺序重排/加价标签/legend 标题的"100ms 轮询自愈"已删除 ——
    // 三者现在全部由 Liquid 服务端渲染 (product-variant-options.liquid /
    // product-variant-picker.liquid), 每次 Dawn Section Rendering 重渲染都
    // 天然正确, 不存在"先短暂错误、下一次轮询才修复"的窗口, 不再需要自愈。
    // legend 标题的"同一 tick 即时更新"仍由下方独立的 change 事件监听器负责
    // (不依赖这个 100ms 轮询)。

    // 如果 widget 丢失（被 Dawn AJAX 覆盖），则重新注入
    var calcEl = document.getElementById('wt-custom-calc');
    if (!calcEl) {
       insertWidget(createWidget());
    }

    var vid = getCurrentVariantId();
    var imprint = getSelectedImprint(vid);
    var targetMoq = DATA.moq;
    if (DATA.variant_moqs && DATA.variant_moqs[imprint]) {
       targetMoq = DATA.variant_moqs[imprint];
    }
    
    var qtyInput = document.querySelector('quantity-input input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || targetMoq) : targetMoq;

    var base = getBasePrice(vid);
    var imprint = getSelectedImprint(vid);
    var surcharge = getSurcharge(imprint);
    var discountPct = getDiscount(qty);

    var unitPrice = base * (1 - discountPct / 100);
    var subtotal = unitPrice * qty;
    var fullPrice = base * qty;
    var youSave = fullPrice - subtotal;

    var elTotal = document.getElementById('wt-calc-total');
    var elDetail = document.getElementById('wt-calc-detail');
    var elSave = document.getElementById('wt-calc-save');
    var elSaveRow = document.getElementById('wt-calc-save-row');

    if (elTotal) elTotal.textContent = fmt(subtotal);
    if (elDetail) elDetail.textContent = fmt(unitPrice) + ' ea × ' + qty + ' qty';

    if (youSave > 0.005 && elSave && elSaveRow) {
      elSave.textContent = fmt(youSave);
      elSaveRow.style.display = '';
    } else if (elSaveRow) {
      elSaveRow.style.display = 'none';
    }

    // 同步 Dawn 原生价格（显示含 surcharge 的实际单价）
    // updateDawnPrice(base + surcharge);  // 已经被原生替代，不需要这段代码了
  }

  /* ── 初始化 ── */

  var widget = createWidget();
  insertWidget(widget);
  update();
  
  // 以 100ms 频率不断纠正 DOM 和更新计算器
  setInterval(update, 100);

  // 监听 quantity
  var qtyInput = document.querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);
  }

  // 监听 variant radio
  var radios = document.querySelectorAll('fieldset input[type="radio"]');
  for (var r = 0; r < radios.length; r++) {
    radios[r].addEventListener('change', function() { setTimeout(update, 50); });
  }

  // URL popstate
  window.addEventListener('popstate', function() { setTimeout(update, 50); });

  // MutationObserver on hidden variant input
  var hiddenId = document.querySelector('input[name="id"]');
  if (hiddenId) {
    new MutationObserver(function() { update(); })
      .observe(hiddenId, { attributes: true, attributeFilter: ['value'] });
  }

  // ====== 追加选项选中值到标题 (e.g. Imprint: Blank) ======
  // 幂等: 已有正确 span 时只更新 textContent (不重建 DOM/不重写 innerHTML);
  // 只有 Dawn 重新渲染把 span 整个替换掉 (缺失) 时才重建一次。这样即使被
  // 周期性 update() 每 100ms 调用, 也不会反复破坏/重建 legend 内部结构,
  // 也不会在 Dawn Section Rendering 替换 DOM 后丢失标题不再恢复。
  function updateLegendText(fieldset) {
    var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    var legend = fieldset.querySelector('legend.form__label');

    // 如果找到了选中的按钮和对应的标题，且它不是 Shopify 原生的色块(原生自带该功能)
    if (!checkedInput || !legend) return;
    if (legend.querySelector('[data-selected-swatch-value]')) return;

    // 提取原标题名 (比如 "Imprint")，以防重复叠加
    var optionName = legend.textContent.split(':')[0].trim();
    // WT: 标题里的当前值同样用显示映射 (仅 Imprint 选项组); 隐藏 input 与
    // 购物车提交值仍是 checkedInput.value 原始值, 这里只改可见文字。
    var displayValue = (optionName.toLowerCase().indexOf('imprint') > -1)
      ? wtImprintDisplayName(checkedInput.value)
      : checkedInput.value;

    var valueSpan = legend.querySelector('.custom-selected-value');
    if (valueSpan) {
      if (valueSpan.textContent !== displayValue) {
        valueSpan.textContent = displayValue;
      }
    } else {
      legend.innerHTML = optionName + ': <span style="font-weight: normal; margin-left: 4px;" class="custom-selected-value">' + displayValue + '</span>';
    }
  }

  function updateLegendTextAll() {
    var fieldsets = document.querySelectorAll('fieldset');
    for (var f = 0; f < fieldsets.length; f++) {
      if (fieldsets[f].querySelector('input[type="radio"]')) {
        updateLegendText(fieldsets[f]);
      }
    }
  }

  // 1. 页面加载时初始化所有选项
  updateLegendTextAll();

  // 2. 监听用户点击切换选项 (即时响应, 不等下一次 100ms 轮询)
  document.addEventListener('change', function(e) {
    if (e.target && e.target.tagName === 'INPUT' && e.target.type === 'radio') {
      var fieldset = e.target.closest('fieldset');
      if (fieldset) {
        // 给一点点延迟，确保 Shopify 的原生 JS 更新完 (如果有的话)
        setTimeout(function() { updateLegendText(fieldset); }, 10);
      }
    }
  });

})();
